/* eslint-disable @typescript-eslint/camelcase */
import i18next from 'i18next';
import { getCacheTranslation, setCacheTranslation } from '../helpers/secureCache';
import { API_TRANSLATIONS } from '../helpers/api';
import { logger, loggerError, loggerOk } from '../helpers/Log';
import { DEVELOPMENT_MODE } from '../constants/constants';
function setTranslations(data, language, setTranslationLoaded, cache) {
    i18next.addResourceBundle(language, 'translation', data.translation);
    i18next.changeLanguage(language);
    if (cache) {
        logger('Adding translationData to cache');
        setCacheTranslation(JSON.stringify(data));
    }
    setTranslationLoaded(true);
}
export function getTranslations(_a) {
    var application = _a.application, language = _a.language, access_token = _a.access_token, setTranslationLoaded = _a.setTranslationLoaded;
    logger('requesting defaults translations: ', application, language);
    try {
        setTranslationLoaded(false);
        var cachedTranslationData = getCacheTranslation();
        if (cachedTranslationData && cachedTranslationData.language === language) {
            // If the translation data is cached and the language is the same, get the info from the cache.
            logger('Getting translationData from cache');
            setTranslations(cachedTranslationData, language, setTranslationLoaded);
            return new Promise(function (resolve) { return resolve(null); });
        }
        localStorage.removeItem('translationData');
        return fetch("".concat(API_TRANSLATIONS, "?language=").concat(language, "&app=").concat(application), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Bearer ".concat(access_token),
            },
        })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            loggerOk('success translations', data);
            setTranslations(data, language, setTranslationLoaded, DEVELOPMENT_MODE);
        });
    }
    catch (error) {
        loggerError('fail get translations');
        loggerError(error);
        setTranslationLoaded(true);
        return new Promise(function (resolve) { return resolve(null); });
    }
}
//# sourceMappingURL=getTranslations.js.map